import { Document, Page, Text } from "@react-pdf/renderer"
import PDFTable from "../../components/react-pdf-table"

export const ProcessWithoutTeacherReport = ({ data, type, styles }) => {

    const headers = [
        { id: 'alias', text: 'Protocolo', width: '20%' },
        { id: 'client.name', text: 'Cliente', large: true },
        { id: 'created_at', text: 'Criado em', format: 'date', width: '15%' }
    ]

    return (
        <Document>
            <Page>
                <Text style={styles.title}>Relatório de atendimentos sem professor</Text>
                <Text style={styles.subtitle}>{data.institution.name} - Emitido em {new Date().toLocaleString()}</Text>
                <PDFTable headers={headers} data={data.data} />
            </Page>
        </Document>
    )
}